import React from "react";

const logos = [
  { name: "Cignus Global",                     logo: "/assets/cignusglobal.png" },
  { name: "FrameNomads",                       logo: "/assets/framenomads.png" },
  { name: "Vervetico",                         logo: "/assets/vervetico.png" },
  { name: "SUKOSU Supply Chain Solutions",     logo: "/assets/sukosu.png" },
  { name: "EUOR ERP",                          logo: "/assets/euorerp.png" },
  { name: "Matricula Education",               logo: "/assets/MATRICULA EDUCATION.png" },
];

const SocialProof = () => {
  return (
    <section className="py-12 sm:py-16 border-y border-slate-200/70 bg-white/60">
      <div className="section">
        <p
          className="text-center text-xs sm:text-sm font-semibold tracking-[0.2em] uppercase text-slate-500"
          data-testid="social-proof-title"
        >
          Trusted by businesses across India
        </p>
        <div className="mt-8 overflow-hidden whitespace-nowrap">
          <div className="inline-flex animate-marquee gap-x-16">
            {[...logos, ...logos].map((l, i) => (
              <div
                key={i}
                className="inline-flex items-center gap-2 text-slate-500 hover:text-slate-900 transition-colors"
              >
                <img
                  src={l.logo}
                  alt={l.name}
                  className="h-6 w-6 object-contain"
                  onError={(e) => {
                    // Fallback to a generic logo if the specific one fails to load
                    e.currentTarget.src = "/assets/logo.png";
                  }}
                />
                <span className="font-display font-semibold text-base sm:text-lg tracking-tight">
                  {l.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
